export default __webpack_public_path__ + "static/media/Instagram_Login.5af76727.png";